/* eslint-disable no-case-declarations */
/* eslint-disable semi */
import {
    LOADING,
    RESULT,
    LIST,
    INIT_CREATE,
    CREATE,
    READ,
    UPDATE,
    DELETE,
    STOCK_UPDATE,
    DETAIL_CHAT,
    CANCEL,
    EDIT,
    CHECK_PAYMENT,
    LIST_SUBS,
    LIST_DEVICE_SUBS,
    UNTAG_DEVICE,
    EXTEND_SUBS
  } from './actionTypes';
  
  const INIT_STATE = {
    loading: true,
  };
  
  const Payout = (state = INIT_STATE, action) => {
    switch (action.type) {
      case LOADING:
        return {
          ...state,
          loading: true,
        };
      case RESULT:
        const newState = {
          ...state,
          loading: false,
        };
        switch (action.payload.actionType) {
          case LIST:
            newState['list'] = action.payload.result;
            break;
          case LIST_SUBS:
            newState['list_subs'] = action.payload.result;
            break;
          case LIST_DEVICE_SUBS:
            newState['list_device'] = action.payload.result;
            break;
          case CHECK_PAYMENT:
            newState['checkPayment'] = action.payload.result;
            break;
          case DETAIL_CHAT:
            newState['detailChat'] = action.payload.result;
            break;
          case UNTAG_DEVICE:
            newState['unTagDevice'] = action.payload.result;
            break;
          case INIT_CREATE:
            newState['initCreate'] = action.payload.result;
            break;
          case CREATE:
            newState['create'] = action.payload.result;
            break;
          case EDIT:
            newState['edit'] = action.payload.result;
            break;
          case CANCEL:
            newState['cancel_'] = action.payload.result;
            break;
          case READ:
            newState['read'] = action.payload.result;
            break;
          case UPDATE:
            newState['update'] = action.payload.result;
            break;
          case STOCK_UPDATE:
            newState['stockUpdate'] = action.payload.result;
            break;
          case EXTEND_SUBS:
            newState['extendedSub'] = action.payload.result;
            break;
          case DELETE:
            newState['delete'] = action.payload.result;
            break;
        }
        return newState;
  
      default:
        return state;
    }
  };
  
  export default Payout;
  